import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import * as AnalyticsHelper from "../../utils/analyticsHelper";
import { sendToGTM } from "../../utils/gtmHelper";
import { connect } from "react-redux";
import * as actions from "../../actions";
import * as Constants from "../../constants";
import InView from "../../utils/InView";

require("./RecommendationItemCard.scss");

class RecommendedItemCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      recommendedItem: props.recommendedItem,
      productId: props.recommendedItem.productId,
      isLoading: false,
      isShowUsp: false,
    };
  }

  addItemToCart = async (quantity) => {
    const {
      recommendedItem: { productId, productType, name: productName },
    } = this.state;

    return await this.props.actions.addToCart({
      productId,
      productType,
      productName,
      quantity,
    });
  };

  handleAddToCart = async () => {
    const { recommendedItem } = this.props;
    this.setState({ isLoading: true });
    const resp = await this.addItemToCart(1);
    if (resp.status === 1) {
      this.props.removeRecommendedItem(recommendedItem);
      this.props.enableAddressSelection();
    }

    const eventObj = {
      eventLabel: Constants.ADD_TO_CART_EVENT,
      source: Constants.RECOMMENDATION_SOURCE,
      eventDetails: {
        ...AnalyticsHelper.getCommonPayloadForAnalytics(
          this.props.customer,
          this.props.cart,
          this.props.user,
        ),
        brand_options_shown: false,
        custom_product_flag: false,
        rx_required: false,
        has_variants: recommendedItem.variants.length > 0,
        product_type: recommendedItem.productType,
        product_price: recommendedItem.mrpDecimal,
        product_id: recommendedItem.productId,
        product_ucode: recommendedItem.ucode,
        product_name: recommendedItem.name,
        property_name: 'ooc_recommendation_bar',
        source: Constants.RECOMMENDATION_SOURCE,
        added_via_recommendation: true,
        product_rank: this.props.rank,
        discount_percentage: recommendedItem.discountPercent,
        discount_amount: recommendedItem.discountDecimal,
        selected_quantity: 1,
        item_type: Constants.ITEM_TYPE_OTC,
        item_recommendation_incentive: recommendedItem.recommendationIncentive,
        user_role: this.props.user.data.userRole,
      },
    };
    sendToGTM(eventObj);

    this.setState({
      isLoading: false,
    });

    return true;
  };

  populateCommonPayloadValues() {
    return {
      ...AnalyticsHelper.getElementDetailsForAnalytics(),
      ...AnalyticsHelper.getItemDetailsForAnalytics(
        this.props.recommendedItem,
        this.props.rank
      ),
      ...AnalyticsHelper.getCommonPayloadForAnalytics(
        this.props.customer,
        this.props.cart,
        this.props.user,
      ),
      num_of_items: this.props.numberOfRecommendations,
    };
  }

  triggerImpressionEvent = (type, intersection) => {
    const { trigger } = intersection;
    const eventObj = {
      eventLabel: type,
      source: Constants.RECOMMENDATION_SOURCE,
      eventDetails: {
        ...this.populateCommonPayloadValues(),
        element_unique_name: 'ooc_recommendation_bar',
        trigger: type === Constants.ELEMENT_CLICKED ? 'on_click' : trigger,
        element_sub_type: this.props.recommendationType,
        agent_id: this.props.user.data.userId,
      },
    };
    sendToGTM(eventObj);
  };

  handleSliderItemInView = (intersection) => {
    const { inView } = intersection;
    if (inView) {
      this.triggerImpressionEvent(Constants.ELEMENT_VIEWED, intersection);
    }
  };

  handleRejectClick = () => {
    if (this.state.isLoading) {
      return;
    }
    this.setState({
      isLoading: true,
    });
    this.props.enableAddressSelection();
    this.props.actions
      .rejetRecommendedProduct({
        productId: this.props.recommendedItem.productId,
        widgetId: this.props.widgetId,
      })
      .then((res) => {
        if (res.status === 1) {
          this.props.removeRecommendedItem(this.props.recommendedItem);
        } else {
          this.setState({
            isLoading: false,
          });
        }
      });
      this.handleClickEventInteraction(Constants.RECOMMENDATION_CUSTOMER_NOT_INTERESTED_CLICKED, 'customer_not_interested')
  };

  getUspArray = () =>
    this.props.recommendedItem.usp.split("\n").map((i, idx) => {
      i = i.replace(`${idx + 1}.`, "");
      return i;
    });

  handleUsp = () => {
    if(!this.state.isShowUsp) {
      this.handleClickEventInteraction(Constants.RECOMMENDATION_INFO_CLICKED, 'info');
    }
    this.setState({
      isShowUsp: !this.state.isShowUsp,
    });
  };

  redirectToPdp = () => {
    this.handleClickEventInteraction(Constants.RECOMMENDATION_NAME_CLICKED, 'product_name', {
      destination_page_name: this.props.recommendedItem.pdpUrl
    });
    window.open(this.props.recommendedItem.pdpUrl, "__blank");
  };

  handleClickEventInteraction = (label, cta, extraProperties = {}) => {
    const eventObj = {
      eventLabel: label,
      source: Constants.RECOMMENDATION_SOURCE,
      eventDetails: {
        ...AnalyticsHelper.getCommonPayloadForAnalytics(
          this.props.customer,
          this.props.cart,
          this.props.user,
        ),
        source: Constants.RECOMMENDATION_SOURCE,
        page_name: 'ooc_cart',
        property_section_name: 'body',
        property_name: 'ooc_recommendation_bar',
        property_cta: cta,
        action_type: 'click',
        item_rank: this.props.rank,
        item_type: this.props.recommendedItem.productType,
        item_id: this.props.recommendedItem.productId,
        ...extraProperties,
      },
    }
    sendToGTM(eventObj);
  }

  render() {
    const { recommendedItem } = this.props;
    const { isLoading, isShowUsp } = this.state;
    return (
      <InView
        onChange={(intersection) => this.handleSliderItemInView(intersection)}
        onClick={(intersection) =>
          this.triggerImpressionEvent(Constants.ELEMENT_CLICKED, intersection)
        }
      >
        <div className="recoItemCard">
          <div className="imageContainer" onClick={this.redirectToPdp}>
            <img
              src={recommendedItem.images.length && recommendedItem.images[0]}
            />
          </div>
          <div className="productDetailsContainer">
            <div className="nameContainer">
              <div className="name" onClick={this.redirectToPdp}>
                {recommendedItem.name}
                <br />
                <span className="volume">
                  {recommendedItem.measurementUnit}
                </span>
              </div>
              {recommendedItem.usp && (
                <img
                  onClick={this.handleUsp}
                  className="info"
                  src={require("@images/info.svg")}
                  alt="i"
                />
              )}
            </div>
            <div className="priceContainer">
              {recommendedItem.discountPercent > 0 ? (
                <div className="price">
                  <span className="mrp">
                    MRP &nbsp;
                    <span>₹{recommendedItem.mrpDecimal}</span>
                  </span>
                  <span className="discount">
                    {recommendedItem.discountPercent}% OFF
                  </span>
                  <div className="sellingPrice">
                    ₹{recommendedItem.salePriceDecimal}
                  </div>
                </div>
              ) : (
                <div className="sellingPrice">
                  ₹{recommendedItem.salePriceDecimal}
                </div>
              )}
              <button
                className="add"
                disabled={isLoading}
                onClick={this.handleAddToCart}
              >
                ADD
              </button>
            </div>
            <div className="rejectContainer">
              <div className="grayLine" />
              <div
                className={`rejectBtn ${
                  this.state.isLoading ? "rejectBtnDisabled" : ""
                }`}
                onClick={this.handleRejectClick}
              >
                Customer Not Interested
              </div>
            </div>
          </div>
          {isShowUsp && (
            <div className="usp_container">
              <div className="head">
                <img src={require("@images/info.svg")} alt="i" />
                <span>About the Product</span>
                <img
                  onClick={this.handleUsp}
                  className="cross"
                  src={require("@images/cross.svg")}
                  alt="x"
                />
              </div>
              <div className="content">
                <ul>
                  {this.getUspArray().map((ele, idx) => (
                    <li key={idx}>{ele}</li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </div>
      </InView>
    );
  }
}

RecommendedItemCard.PropTypes = {
  recommendedItem: PropTypes.object.isRequired,
  cart: PropTypes.object.isRequired,
  actions: PropTypes.object,
  rank: PropTypes.number,
  numberOfRecommendations: PropTypes.number,
  recommendationType: PropTypes.number,
  removeRecommendedItem: PropTypes.func.isRequired,
  enableAddressSelection: PropTypes.func.isRequired,
  widgetId: PropTypes.number.isRequired,
};

RecommendedItemCard.defaultProps = {
  actions: {},
  rank: 0,
  numberOfRecommendations: 0,
  recommendationType: 1,
};

export default connect(
  (state) => ({
    cart: state.cart,
    customer: state.customer,
    user: state.user,
  }),
  (dispatch) => ({
    actions: bindActionCreators(actions, dispatch),
  })
)(RecommendedItemCard);
